import React from 'react';
import { useTranslation } from 'react-i18next';
import type { InvoicePaymentModalProps } from './InvoicePaymentModal.types';
import { InvoicePaymentSummary } from './InvoicePaymentSummary';
import { InvoicePaymentDialogs } from './InvoicePaymentDialogs';
import * as S from './InvoicePaymentModal.styles';
import { ModalDrawer } from '@/components/UI/ModalDrawer';
import { PaymentMethods } from '@/components/Payment/PaymentMethods';
import { PaymentAgreementText } from '@/components/Payment/PaymentAgreementText';
import { Button } from '@/components/UI/Button/Button';
import { PaymentMethod } from '@/api/types/payments.types';

const INVOICE_PAYMENT_METHODS_ORDER = [
  PaymentMethod.Card,
  PaymentMethod.My_card,
  PaymentMethod.Terminal,
  PaymentMethod.Wallet,
] as const;

export function InvoicePaymentModal({
  cashBalance,
  controller,
  details,
  isLoading,
  isOpen,
  onBack,
  onClose,
  onPay,
  title = details.packageName,
}: InvoicePaymentModalProps) {
  const { t } = useTranslation();

  const { cardId, payment, paymentMethods, setCardId, setPayment } = controller;
  const { packageName } = details;

  return (
    <>
      <ModalDrawer
        dataTestId="package-invoice-modal"
        isOpen={isOpen}
        onBack={onBack}
        onClose={onClose}
        title={title}
        bottom={
          <S.Footer>
            <Button
              data-testid="package-invoice-pay"
              data-stat={
                payment === PaymentMethod.My_card
                  ? 'invoice-pay-with-token'
                  : undefined
              }
              appearance="secondary"
              borderRadius={14}
              disabled={isLoading}
              isFullWidth
              isLoading={isLoading}
              onClick={onPay}
            >
              {t('common.pay')}
            </Button>
          </S.Footer>
        }
      >
        <S.Content>
          <InvoicePaymentSummary details={details} />
          <PaymentMethods
            cardId={cardId}
            payment={payment}
            paymentMethods={paymentMethods}
            paymentMethodsOrder={INVOICE_PAYMENT_METHODS_ORDER}
            setCardId={setCardId}
            setPayment={setPayment}
            walletDetails={{
              balance: cashBalance,
              title: t('pages.cabinet.main_balance'),
            }}
          />
          <PaymentAgreementText />
        </S.Content>
      </ModalDrawer>

      <InvoicePaymentDialogs
        controller={controller}
        packageName={packageName}
      />
    </>
  );
}
